import React from "react";
import { IoMdCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import StripePaymentForm from "../Forms/StripePaymentForm";
import Badge from "../Badge/Badge";

const CardWithText = ({
  cardTitle,
  cardPrice,
  cardContent_1,
  cardContent_2,
  cardContent_3,
  cardContent_4,
  cardContent_5,
  cardContent_6,
  cardContent_7,
  cardContent_8,
  cardContent_9,
  cardContent_10,
  cardContent_11,
  cardBtnName,
  onClick,
  plan,
  planKey,
  checkOutStatus,
  currentPlan,
  questionArray,
  countryLoading,
  planPhase,
  subscriptionExpiredShow,
  subscriptionCookie,
  pricingPlan,
  is_trial_started,
  pricingResponse,
  recallFun,
  subscription_going_to_end
}) => {
  const datas = [
    { cardContents: cardContent_1 },
    { cardContents: cardContent_2 },
    { cardContents: cardContent_3 },
    { cardContents: cardContent_4 },
    { cardContents: cardContent_5 },
    { cardContents: cardContent_6 },
    { cardContents: cardContent_7 },
    { cardContents: cardContent_8 },
    { cardContents: cardContent_9 },
    { cardContents: cardContent_10 },
    { cardContents: cardContent_11 },
  ];

  var loadingArray = [1, 2, 3, 4, 5, 6]

  return (
    <div className={`card border-0 shadow-sm h-100 rounded-4 ${currentPlan && !countryLoading ? "payment_card_active" : ''}`}>
      {
        countryLoading === false ?

          <React.Fragment>
            <Badge currentPlan={currentPlan} />

            <div className="card-body ps-0 py-5">
              <h2 className="card-plan fw-bold mx-5 mt-4 mb-3 brand-color">
                {cardTitle}
              </h2>
              <h2 className="card-price mx-5 fw-bold mb-4">
                {
                  cardPrice ?
                    <>
                      {planPhase === "Employer" && cardPrice !== "Free" ? cardPrice : null}
                      {cardPrice !== "Free" && planPhase === "Employer" ?
                        <span className="fs-6">/yr</span>
                        :
                        null
                      }
                    </>
                    :
                    null
                }

                {
                  plan === "Free" && planPhase === "Employer" ?
                    "7 Days trial"
                    :
                    null
                }
              </h2>
              <hr className="ms-5 me-4 border-secondary" />

              <ul className="Pricing-features mx-3 ps-0 list-group">
                {questionArray.map((v, i) => {
                  return (
                    datas[i].cardContents !== "" ?
                      <li key={i} className="fw-medium priceHead list-unstyled row">
                        <div className="pricing-icon">
                          {datas[i].cardContents === "No" ? (
                            <RxCross2 className="mx-2 fs-4 text-danger" />
                          ) : (
                            <IoMdCheckmark className="mx-2 fs-4 text-success" />
                          )}
                        </div>
                        <div className="col mb-2">
                          <p className="m-0">{v}</p>
                          <p className="pricesubtitle">{datas[i].cardContents}</p>
                        </div>
                      </li>
                      :
                      null
                  );
                })}
              </ul>
            </div>
            <div className=" card-footer border-0 text-center bg-transparent py-4 payment_card_footer_height">
              <StripePaymentForm
                cardBtnName={cardBtnName}
                onClick={onClick}
                plan={plan}
                checkOutStatus={checkOutStatus}
                planKey={planKey}
                currentPlan={currentPlan}
                cardTitle={cardTitle}
                planPhase={planPhase}
                subscriptionExpiredShow={subscriptionExpiredShow}
                pricingPlan={pricingPlan}
                is_trial_started={is_trial_started}
                pricingResponse={pricingResponse}
                recallFun={recallFun}
                subscription_going_to_end={subscription_going_to_end}
              />
            </div>
          </React.Fragment>

          :
          <div className="placeholder-glow">
            <div className="card-body  ps-0">
              <span className="ms-5 fs-3">
                <span className="placeholder py-4 my-3 rounded-3 col-7"></span>
              </span>

              <span className="ms-5 fs-3">
                <span className="placeholder py-4 rounded-3 col-7"></span>
              </span>

              <hr className="ms-4 pb-4" />


              <h2 className="ms-4">

                {loadingArray.map((val, ind) => {
                  return (
                    <div className="mt-4" key={ind}>

                      <span className="d-flex align-items-center ">
                        <span className="placeholder rounded-3 fs-2 px-3 me-2 col-1 "></span>
                        <span className="placeholder rounded-3 fs-5 col-9 "></span>
                      </span>

                      <span className="ms-3">
                        <span className="placeholder rounded-3 fs-5 ms-4 col-8"></span>
                      </span>
                    </div>
                  )
                })}
              </h2>


              <span className="d-flex align-items-center justify-content-center">
                <h2 className="placeholder rounded-5 col-6 my-4 py-4"></h2>
              </span>
            </div>

          </div>
      }
    </div>
  );
};

export default CardWithText;